module.exports = __webpack_public_path__ + "img/NOA-logo-square-alpha.555331ac.png";